import { render } from "./Instances.vue?vue&type=template&id=a9198444"
import script from "./Instances.vue?vue&type=script&lang=js"
export * from "./Instances.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__